import dynamic from "next/dynamic";
// import CombosPage from "../../src/combos/CombosPage.tsx";
const CombosPage = dynamic(() => import("../../src/combos/CombosPage.tsx"), {
  ssr: false,
});

export default function Player({ exaltedGroups }) {
  return <CombosPage exaltedGroups={exaltedGroups} />;
}

export async function getStaticProps() {
  const exaltedsResp = await fetch(
    `https://ap.tft.tools/static/s11/exalteds.json`,
  );
  const exaltedGroups = await exaltedsResp.json();

  return {
    props: {
      exaltedGroups,
    },
    revalidate: 3600,
  };
}
